export const dateToUTCWithoutMS = (date: Date): string =>
  date.toISOString().split('.')[0] + 'Z';
